export default __webpack_public_path__ + "static/media/SimonNjoku.a4d51ead.svg";